module.exports = __webpack_public_path__ + "static/AppstoreWhite-015175851a1bb7dcffa93a77ae331902.svg";